export let
  STATES = {
    init : "Init",
    loading : "Loading",
    editing : "Editing",
    updating: "Updating",
    success: "Success",
    error: "Error"
  }
